import { atom } from 'jotai';

import { useAbortableMutation } from '@/shared/hooks/use-abortable-mutation';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';
import {
  RequestLookalikeKeywords,
  type LookalikeKeywordExtractionRequestDTO,
} from '..';

const lookalikeSuggestionPendingAtom = atom(false);

export const useRequestLookalikeKeywords = () => {
  const { workspaceId } = useWorkspaceId();

  return useAbortableMutation({
    mutationFn: (request: LookalikeKeywordExtractionRequestDTO, signal) =>
      RequestLookalikeKeywords(workspaceId, request, signal),
    pendingAtom: lookalikeSuggestionPendingAtom,
    requestKey: 'creator:lookalike-suggestions',
  });
};

export const useRequestLookalikeSuggestions = useRequestLookalikeKeywords;
